import React, { useState, useEffect } from "react";
import { pb4y as api } from "../../../../../services/apis";
import { producaov2 as api2 } from "../../../../../services/apis";
import { Button, Form, Input, Loader } from "semantic-ui-react";
import { toast } from "react-toastify";

import { Container, Content, Title, Label, Field } from "./styles";

import swal from "sweetalert";
import { Link, withRouter } from "react-router-dom";
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";
import { isAuthAdmin } from "../../../../../services/auth";

const EditarUsuarios = (props) => {
  const id = props.match.params.id;
  const [loading, setLoading] = useState(true);
  const [usuario, setUsuario] = useState({});
  const [cancelamento, setCancelamento] = useState(false);

  const optionPlano = [
    { id: 106091, text: "PREMIUM" },
    { id: 105453, text: "STARTER" },
    { id: 8888, text: "Gratuito" },
    { id: 110144, text: "Estudante Permium" },
    { id: 1111, text: "Estudante Gratuito" },
    { id: 113722, text: "Premuim Anual" },
  ];

  useEffect(() => {
    loadAuth();
    loadUsuario();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();
    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const loadUsuario = async () => {
    await api
      .get(`users/${id}`,{
        headers: {
          access_token: `voitto-token ${localStorage.getItem(
            'oauth_token'
          )}`
        }
      })
      .then(async (res) => {
        setUsuario(res.data);
        setLoading(false);
      })
      .catch((err) => {
        swal("Não foi possível carregar os valores", err, "error");
        setLoading(false);
      });
  };

  const resetPassword = async () => {
    await api
      .put(`users/${id}`, { password: "Pocket@123" },{
        headers: {
          access_token: `voitto-token ${localStorage.getItem(
            'oauth_token'
          )}`
        }
      })
      .then((res) => {
        toast.success("Senha alterada com sucesso!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      })
      .catch((err) => {
        toast.error("Não foi possivel alterar a senha!!!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        console.error(err);
      });
  };

  const update = async () => {
    const payload = {
      email: usuario.email,
      name: usuario.name,
      plano: usuario.plano,
      celular: usuario.celular,
      admin: usuario.admin,
      costumer_id: usuario.costumer_id,
      is_pay: usuario.is_pay,
      subscription_id: usuario.subscription_id,
      endereco: usuario.endereco,
      cod_postal: usuario.cod_postal,
      cidade: usuario.cidade,
      pais: usuario.pais,
      estado: usuario.estado,
      cpf: usuario.cpf,
      id_plano: usuario.id_plano,
      cupom: usuario.cupom,
      imagem: usuario.imagem,
      bairro: usuario.bairro,
      num_casa: usuario.num_casa,
    };
    api
      .put(`users/${id}`, payload,{
        headers: {
          access_token: `voitto-token ${localStorage.getItem(
            'oauth_token'
          )}`
        }
      })
      .then(async (res) => {
        let logs = {
          local: "PocketBook",
          texto: `editou o usuario de id=${id}`,
        };
        await api2.post("system_logs", { acao: JSON.stringify(logs) });

        toast.success("Usuario modificado com sucesso!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        props.history.push("/admin/blog/pocketbook4you/usuarios");
      })
      .catch((err) => {
        toast.error("Não foi possivel alterar o usuario!!!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        props.history.push("/admin/blog/pocketbook4you/usuarios");
      });
  };
  const handleCancel = () => {
    api
      .post('cancelamento/user', {
        id_user: usuario.id,
        id_subscription: usuario.subscription_id
      }).then(res => {
        if (res.status === 200) {
          setCancelamento(true);
          toast.success("Cancelamento concluído", {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          setInterval(function () { window.location.reload() }, 5000);

        }
      }).catch(() => {
        toast.error("Erro no cancelamento. Favor contatar ti", {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      });

  };

  return (
    <>
      <Container>
        <AdminMenu />
        {loading ? (
          <Loader active inline="centered" size="massive" />
        ) : (
          <Content>
            <Title>PocketBook4You Usuario [id: {id}]</Title>

            <Form>
              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="Nome"
                  placeholder="Nome"
                  value={usuario.name}
                  onChange={(e) => {
                    setUsuario({ ...usuario, name: e.target.value });
                  }}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="Email"
                  placeholder="Email"
                  value={usuario.email}
                  onChange={(e) => {
                    setUsuario({ ...usuario, email: e.target.value });
                  }}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Button color="green" onClick={() => resetPassword()}>
                  Resetar senha!
                </Button>
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="Celular"
                  placeholder="Celular"
                  value={usuario.celular}
                  onChange={(e) => {
                    setUsuario({ ...usuario, celular: e.target.value });
                  }}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="CPF"
                  placeholder="CPF"
                  value={usuario.cpf}
                  onChange={(e) => {
                    setUsuario({ ...usuario, cpf: e.target.value });
                  }}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field>
                  <Label>Plano</Label>
                  <select
                    value={usuario.id_plano}
                    onChange={(e) =>
                      setUsuario({ ...usuario, id_plano: e.target.value })
                    }
                  >
                    {optionPlano.map((valor) => (
                      <option value={valor.id}>{valor.text}</option>
                    ))}
                  </select>
                </Form.Field>
              </Form.Group>
              {
                usuario.id_plano !== 8888 && (
                  <Form.Group widths="equal">
                    <Button color="red" onClick={() => handleCancel()}>
                      Tornar gratuito
                    </Button>
                  </Form.Group>
                )
              }
              {
                cancelamento && (
                  <Form.Group widths="equal">
                    <Field>
                      <p>Usuário foi cancelado. No caso de cupom o cancelamento é efetivado imediatamente.</p>
                      <p>Para usuários que fazem pagamentos com cartão, os mesmos, ainda terão 1 mês sem cobranças</p>
                    </Field>
                  </Form.Group>
                )
              }

              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="Costumer_id"
                  placeholder="Costumer_id"
                  value={usuario.costumer_id}
                  onChange={(e) => {
                    setUsuario({ ...usuario, costumer_id: e.target.value });
                  }}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="is_pay"
                  placeholder="is_pay"
                  value={usuario.is_pay}
                  onChange={(e) => {
                    setUsuario({ ...usuario, is_pay: e.target.value });
                  }}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="Subscription_id"
                  placeholder="Subscription_id"
                  value={usuario.subscription_id}
                  onChange={(e) => {
                    setUsuario({ ...usuario, subscription_id: e.target.value });
                  }}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="Cupom"
                  placeholder="Cupom"
                  value={usuario.cupom}
                  onChange={(e) => {
                    setUsuario({ ...usuario, cupom: e.target.value });
                  }}
                />
              </Form.Group>
              <Form.Group>
                <Form.Field
                  control={Button}
                  onClick={() => {
                    update();
                  }}
                >
                  Enviar
                </Form.Field>
                <Link to="/admin/blog/pocketbook4you/usuarios">
                  <Button color="secondary">Cancelar</Button>
                </Link>
              </Form.Group>
            </Form>
          </Content>
        )}
      </Container>
    </>
  );
};

export default withRouter(EditarUsuarios);
